export default {
  title: {
    offerLetterManagement: 'Offer管理',
    offerLetterInviteRecordManagement: 'Offer模板',
    offerLetterTemplateList: 'Offer模板',
    offerLetterTemplateAdd: '新增Offer模板',
    offerLetterTemplateEdit: '编辑Offer模板',
    offerLetterTemplateView: '查看Offer模板',
    offerLetterTemplateFieldList: 'Offer字段',
    offerLetterTemplateFieldEdit: '编辑Offer字段',
    offerLetterTemplateFieldAdd: '新增Offer字段',
    offerLetterInviteRecordList: 'Offer发放记录'
  },
  label: {
    templateName: '名称',
    templateStatus: '状态',
    contentLabel: 'Offer模板',
    templateFieldKey: 'Offer字段占位符',
    templateFieldCnName: '中文名',
    templateFieldEnName: '英文名',
    templateFieldCreateType: '类型',
    templateFieldValueType: '字段值类型',
    systemTemplateField: '系统字段',
    hrCreateTemplateField: '自定义字段',
    templateFieldStatus: '状态',
    templateFieldRequired: '必填',
    offerLetterField: 'Offer字段',
    offerLetterTemplate: 'Offer模板',
    offerLetterInviteRecord: 'Offer发放记录',
    inviteOfferLetterDate: '发放日期',
    inviteCompany: '公司',
    inviteJobName: '职位',
    inviteOfferLetterTemplate: 'Offer模板',
    inviteRecruiter: '招聘人员',
    inviteCandidate: '候选人',
    inviteOfferLetterStatus: '状态',
    templateFieldType: '填写人',
    templateFieldHR: '招聘人员',
    templateFieldCandidate: '候选人',
    companyName: '公司',
    addOption: '新增字段值',
    editOption: '编辑字段值'
  },
  btn: {
    add: '新增',
    view: '查看',
    openTemplateFieldList: '模板字段列表',
    export: '导出',
    sendNotice: '发送提醒',
    resendInvite: '重发Offer'
  },
  message: {
    templateHeaderRequired: '头图必填',
    templateKeyRequired: '该字段必填',
    templateNameRequired: '名称必填',
    keyIsEnglish: '该字段必须为英文',
    deleteOption: '您确定要删除字段值 {cnName}-{enName}？'
  },
  placeholder: {
    search: '搜索'
  },
  upload: {
    pc: {
      tip: '添加电脑端图片',
      subTip: '推荐大小为：1100*370且小于5MB'
    },
    mobile: {
      tip: '添加手机端图片',
      subTip: '推荐大小为：750*450且小于5MB'
    }
  },
  INVITE_STATUS: {
    INVITED: '已邀请',
    ACCEPTED: '已接受',
    REJECTED: '已拒绝'
  },
  OFFER_EVENT_STATUS: {
    INVITED: 'Offer已发送',
    ACCEPTED: 'Offer已接受',
    REJECTED: 'Offer已拒绝',
    RE_INVITED: '调整Offer',
    REMINDED: 'Offer已提醒'
  },
  OFFER_LETTER_TEMPLATE_FIELD_TYPE: {
    DATE: '日期',
    SELECT: '多选',
    SIGN: '签名',
    SINGLE: '单选',
    TEXT: '单行文本',
    TEXTAREA: '多行文本'
  }
}
